import { useQuery } from '@tanstack/react-query'
import { warehouseApis } from '../gateways/breadstack/warehouseApis'
import type { WHLocation } from '../types/warehouse'

interface UseWarehousesOptions {
  enabled?: boolean
}

export const useWarehouses = (
  storeId: string,
  organizationId?: string,
  options: UseWarehousesOptions = {},
) =>
  useQuery<WHLocation[]>({
    queryKey: ['warehouses', storeId, organizationId],
    queryFn: () => warehouseApis.getList(storeId, organizationId),
    enabled: Boolean(storeId) && (options.enabled ?? true),
    initialData: [],
  })
